import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endPoint from "../EndPoint/endpoint";

export const CheckoutApi = createAsyncThunk(
  "checkout/initiatePayment",
  async (billingAddress, thunkAPI) => {
    const billingAddressData = {
      firstName: billingAddress?.firstName,
      lastName: billingAddress?.lastName,
      email: billingAddress?.email,
      streetAddress: billingAddress?.streetAddress,
      city: billingAddress?.city,
      state: billingAddress?.state,
      pinCode: billingAddress?.pinCode,
      phone: billingAddress?.phone,
      paidAmount: billingAddress?.codAmount ? billingAddress?.codAmount : "",
    };
    try {
      let storedUuid = localStorage.getItem("uuid");
      const Token = localStorage.getItem("loginData");
      const response = await axios.post(
        endPoint.PLACEORDER,
        {
          paymentMethod: billingAddress?.paymentMethod,
          billingAddress: billingAddressData,
          sessionId: storedUuid ? storedUuid : "",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: Token ? `Bearer ${Token}` : "",
          },
        }
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const checkoutSlice = createSlice({
  name: "checkout",
  initialState: {
    CheckoutData: null,
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(CheckoutApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(CheckoutApi.fulfilled, (state, action) => {
        state.loading = false;
        state.CheckoutData = action;
        if (action.payload.html) {
          createAndSubmitFreeChargeForm(action.payload.html);
        }
      })
      .addCase(CheckoutApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action;
      });
  },
});

export default checkoutSlice.reducer;

function createAndSubmitFreeChargeForm(html) {
  const checkoutContainer = document.createElement("div");
  checkoutContainer.style.display = "none";
  document.body.appendChild(checkoutContainer);
  checkoutContainer.innerHTML = html;

  const form = checkoutContainer.querySelector("form");
  if (form) {
    form.submit();
  } else {
    console.error("FreeCharge form not found in response.");
    alert("FreeCharge payment could not be initiated.");
  }
}
